import { render } from "./LabelComponent.vue?vue&type=template&id=275c969e&ts=true&lang=pug"
import script from "./LabelComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelComponent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__